var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"small e-tbl"},[_c('thead',{staticClass:"table-thead"},[_vm._t("table-header")],2),_c('tbody',{staticClass:"table-tbody"},[_vm._t("table-body")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }